import axios from "axios";
import { BASE_URL } from "../../utils/constants";
import { performLogout } from "../../utils/logout";

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem("authToken");

  if (accessToken && config.auth !== false) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't logout on failed login attempts
      const url = error.config?.url || "";
      if (url.includes("/auth/login")) {
        return Promise.reject(error);
      }
      performLogout();
      // Return a never-resolving promise to suppress downstream error handlers
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

export default api;
